import { useCallback, useEffect, useState } from "react";
import { fetchTvtZone } from "../services/api.js";

/**
 * §F.4 Price-Band Zone — Discount / Neutral / Premium. The backend
 * reads the TreasuryExecutor's `currentZone()` view server-side; we
 * just relay the answer. Polls every 60s by default — zones flip on
 * keeper execution intervals (5-30 min), not block-by-block, so a
 * tighter cadence wastes RPC.
 */
export function useTvtZone({ pollMs = 60_000 } = {}) {
    const [data, setData] = useState(null);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const live = await fetchTvtZone();
            setData(live);
            setError(null);
        } catch (err) {
            setError(err?.message || "Failed to fetch zone");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
        if (!pollMs) return undefined;
        const handle = setInterval(refresh, pollMs);
        return () => clearInterval(handle);
    }, [refresh, pollMs]);

    return { data, isLoading, error, refresh };
}
